// deno-lint-ignore-file no-unused-vars
import { h, Fragment } from '../jsx-runtime.ts';

class TmkSearchBar extends HTMLElement {
  private timer: number | null = null;

  connectedCallback() {
    const input = <input
      type="search"
      className="search-input"
      placeholder="Szukaj..."
      onInput={(e: Event) => this.handleInput(e)}
    /> as HTMLInputElement;

    this.replaceChildren(input);
  }

  private handleInput(e: Event) {
    if (this.timer) clearTimeout(this.timer);
    const value = (e.target as HTMLInputElement).value.trim();
    this.timer = window.setTimeout(() => {
      this.dispatchEvent(new CustomEvent('search', {
        detail: value,
        bubbles: true,
      }));
    }, 300);
  }
}

customElements.define('tmk-search-bar', TmkSearchBar);
